export default {
  title: 'Leaderboard',
  menu: 'Leaderboard',
  status: {
    shares: 'Shares',
    submits: 'Submits',
    views: 'Views',
    applied: 'Applied',
    interviewed: 'Interviewed',
    onboard: 'Onboarded',
    probation: 'Pass Probation',
    all: 'Rewards'
  }
}
